import styled from '@emotion/styled';

const Spacer = styled.div`
  ${(props) =>
    props.break2 &&
    `
      position: relative;
      margin-bottom: 50px;
    `}

  ${(props) =>
    props.break3 &&
    `
      position: relative;
      margin-bottom: 70px;
    `}

  ${(props) =>
    props.break5 &&
    `
      position: relative;s
      margin-bottom: 110px;
    `}

  ${(props) =>
    props.line &&
    `
      border: 1px solid var(--gray);
      margin-top: 1.5em;
      margin-bottom: 1.5em;
    `}
`;

export { Spacer };
